import React, { useRef } from "react";
import './App.css';
import Header from './components/header/header';
import Banner from './components/banner/banner';
import Footer from './components/footer/footer';
import Contact from './components/contact/contact';
import TechnologySoftware from './components/technology-software/technology-software';
import Services from './components/services/services';

function App() {

  const bannerRef = useRef(null); 
  const technologySoftwareRef = useRef(null);
  const servicesRef = useRef(null);
  const contactRef = useRef(null);

  const scrollToSection = (ref) => {
    ref.current.scrollIntoView({ behavior: "smooth" });
  };


  return (
    <div className="App">
      <Header
              onScrollToBanner={() => scrollToSection(bannerRef)}
              onScrollToTechnology={() => scrollToSection(technologySoftwareRef)}
              onScrollToServices={() => scrollToSection(servicesRef)}
              onScrollToContact={() => scrollToSection(contactRef)}
      />
      <Banner ref={bannerRef} />
      <TechnologySoftware ref={technologySoftwareRef} />
      <Services   ref={servicesRef}/>
      <Contact  ref={contactRef}/>
      <Footer />
    </div>
  );
}

export default App;
